import React, { useEffect, useState } from 'react';
import {
    Container,
    Paper,
    makeStyles
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import ConsentCore from 'src/components/ConsentCore';

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
    },
    mainPaper: {
        padding: theme.spacing(3),
        backgroundColor: '#fff'
    },
    header: {
        marginBottom: theme.spacing(3),
        textAlign: 'center'
    },
    submitButton: {
        marginTop: theme.spacing(3),
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
}));

const ConsentPage = () => {
    const { t } = useTranslation('overview');
    const classes = useStyles();

    const [consumerId, setConsumerId] = useState(null);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const consumerIdFromUrl = urlParams.get('consumerId');
        if (consumerIdFromUrl) {
            setConsumerId(consumerIdFromUrl);
        } else {
            console.error(t('consumerIdNotFoundConsole'));
        }
    }, []);

    if (!consumerId) {
        return (
            <Container maxWidth="md" className={classes.container}>
                <Paper className={classes.mainPaper}>
                    <Alert severity="error">
                        {t('consumerIdNotFoundMessage')}
                    </Alert>
                </Paper>
            </Container>
        );
    }

    return (
        <Container maxWidth="lg" className={classes.container}>
            <Paper className={classes.mainPaper}>
                <ConsentCore
                    ConsumerId={consumerId}
                />
            </Paper>
        </Container>
    );
};

export default ConsentPage;
